<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
  import {findComponentsDownward, each} from './../assist';
  import Emitter from './../emitter';

  const prefixCls = 'am-checkbox-group';
  export default {
    name: 'CheckboxGroup',
    mixins: [Emitter],
    props: {
      value: {
        type: Array,
        default() {
          return []
        }
      }
    },
    created() {
    },
    data() {
      return {
        currentValue: this.value,
        childrens: []
      }
    },
    mounted() {
      this.update(true);
    },
    computed: {
      classes() {
        return [
          `${prefixCls}`
        ]
      }
    },
    methods: {
      update(update) {
        let childrens = this.childrens = findComponentsDownward(this, 'Checkbox');
        if (childrens) {
          const {value} = this;
          each(childrens, (child) => {
            child.model = value;
            if (update) {
              child.currentValue = value.indexOf(child.label) >= 0;
              child.group = true
            }
          })
        }
      },
      change(data) {
        this.currenValue = data;
        this.$emit('input', data);
        this.$emit('on-change', data)
      }
    },
    watch: {
      value() {
        this.update(true);
      }
    },
    destroyed() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// components/CheckboxGroup/CheckboxGroup.vue